import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RouteMatcherService, RouteSuggestion } from '../../services/route-matcher.service';

@Component({
  selector: 'app-page404',
  standalone: false,
  templateUrl: './page404.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page404.component.scss']
})
export class Page404Component implements OnInit {
  suggestions: RouteSuggestion[] = [];

  constructor(
    private router: Router,
    private routeMatcher: RouteMatcherService
  ) {}

  ngOnInit(): void {
    const currentUrl = this.router.url;
    
    // Check for best match (high similarity) for immediate redirect
    const bestMatch = this.routeMatcher.getBestMatch(currentUrl, 85);
    
    if (bestMatch) {
      // Immediately redirect without countdown
      this.router.navigate([bestMatch]);
    } else {
      // Find similar routes for suggestions (lower threshold)
      this.suggestions = this.routeMatcher.findSimilarRoutes(currentUrl, 50, 5);
    }
  }

  navigateToSuggestion(path: string): void {
    this.router.navigate([path]);
  }
}
